import { css } from '@backyard-ui/styles';

const GridStyles = css({
  display: 'flex',
  flexWrap: 'wrap',
  boxSizing: 'border-box',
  variants: {
    gutter: {
      xs: {
        marginX: 'calc(($1 / 2) * -1)',
      },
      sm: {
        marginX: 'calc(($2 / 2) * -1)',
      },
      md: {
        marginX: 'calc(($3 / 2) * -1)',
      },
      lg: {
        marginX: 'calc(($4 / 2) * -1)',
      },
      xl: {
        marginX: 'calc(($5 / 2) * -1)',
      },
    },
    noGutters: {
      true: {
        marginX: 0,
      },
    },
    isReverse: {
      true: {
        flexDirection: 'row-reverse',
      },
    },
  },
  defaultVariants: {
    gutter: 'lg',
    noGutters: false,
    isReverse: false,
  },
});

export default GridStyles;
